import { apiRequest } from '@/common/utils/request.common'
import {
  API_BASE_URL_STORE,
  HTTP_METHOD_GET,
} from '@/common/utils/request.const'
import { normalizeConsentRenewInfo } from '@/common/normalize/normalize-consent-renew-info'

/**
 * 동의 정보 필요 조희
 * @returns {Promise<{data: undefined}|{error}|AxiosResponse>}
 */
export const getConsentRenewInfo = async () => {
  try {
    const response = await apiRequest({
      url: `${API_BASE_URL_STORE}/v1/consent/renew/info`,
      method: HTTP_METHOD_GET,
    })

    if (!response) return { data: undefined, error: null }

    response.data = normalizeConsentRenewInfo(response?.data)
    response.error = null

    return response
  } catch (error) {
    return {
      data: undefined,
      error: error.response,
    }
  }
}
